// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"userManagement_wrapper__3z5Dp","left":"userManagement_left__25ueo","right":"userManagement_right__3pUBb"};